import React, { useEffect, useRef, useState } from "react";
import { Header, Heading, HeadingGroup, Panel, Text, Input, Grid, Row, Col, Button } from "rsuite";
import { useLocation } from "react-router-dom";
import styles from "./Auth.module.scss";

import { Formik } from "formik";
import { ErrorMessage } from "components";
import { otpVerifyValidation } from "validation/AuthValidation";
import { toast } from "react-toastify";
import AuthAPI from "services/AuthAPI";
import { useDispatch } from "react-redux";
import { updatePermissions, updateRoleName, updateUserLogin } from "../../redux/slices/userSlice";
import { storeToken } from "../../utils/storage";
import { IntroScreen, IntroDisplayTime } from "./IntroScreen";

export default function VerifyOTP() {
  const [showIntro, setShowIntro] = useState(false);
  const [isIntroImgLoaded, setIsIntroImgLoaded] = useState(null);
  const [verifyOTPResp, setVerifyOTPResp] = useState({});
  const location = useLocation();
  const isIntroImageLoadCallback = useRef(null)

  const userID = location.state?.userID || "";

  const apiInstance = new AuthAPI();

  const dispatch = useDispatch();

   useEffect(() => {
      isIntroImageLoadCallback.current = ({isIntroImgLoaded}) => {
        setIsIntroImgLoaded(isIntroImgLoaded)
      }
  
    }, [isIntroImgLoaded])
  
    useEffect(() => {
      if(isIntroImgLoaded && verifyOTPResp.statusCode === 200) {
          setShowIntro(true)
          setTimeout(() => {
            dispatch(updateUserLogin(true));
          }, IntroDisplayTime);
        }
  
    }, [isIntroImgLoaded, verifyOTPResp, dispatch])

  return (
    <>
      <Header className={styles.top__header}>ॐ नमो भगवते वासुदेवाय नमः</Header>
      <div className={styles.container}>
        <div className={styles.login__card}>
          <div className={styles.logo}>
            <img src="/images/logo2.png" alt="Kamakshi Money" />
          </div>
          <Panel className={styles.panel} shaded>
            <HeadingGroup className="text-center">
              <Heading level={4} className="mb-5">
                Verify OTP 👋
              </Heading>
              <Text muted>We have sent the verification code to your email address</Text>
            </HeadingGroup>

            <div>
              <Formik
                initialValues={{
                  otp: "",
                }}
                validationSchema={otpVerifyValidation}
                onSubmit={async (values, { setSubmitting }) => {
                  setSubmitting(true);
                  try {
                    const res = await apiInstance.verifyOTPAPI(values, userID);
                    setVerifyOTPResp(res);
                    if (res?.statusCode === 200) {
                      storeToken(res.data.token);
                      dispatch(updatePermissions(res.data.permissions));
                      dispatch(updateRoleName(res.data.roleName));
                      toast.success(verifyOTPResp?.message);
                    } else {
                      toast.error(verifyOTPResp?.message);
                    } 
                  } catch (error) {
                    console.error(error?.message);
                    
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid fluid>
                      <Row>
                        <Col sm={24}>
                          <div className="form-group">
                            <label className="form-label">Enter OTP</label>
                            <Input
                              placeholder="Enter Your OTP"
                              value={values.otp || ""}
                              type="number"
                              onChange={(value) => {
                                setFieldValue("otp", value);
                              }}
                            />
                            <ErrorMessage touched={touched.otp} error={errors.otp} />
                          </div>
                        </Col>

                        <Col sm={24}>
                          <Button block type="submit" appearance="primary" loading={isSubmitting} className="mt-10">
                            Verify Now!
                          </Button>
                        </Col>
                      </Row>
                    </Grid>
                  </form>
                )}
              </Formik>
            </div>
          </Panel>
        </div>
      </div>
      <IntroScreen
        showIntro={showIntro}
        updateCallbackRef={isIntroImageLoadCallback}
      />
    </>
  );
}
